import React from 'react';
import EdsTextLink from '@hedtech/react-design-system/core/es/TextLink';
const TextLink = (props) => (React.createElement(EdsTextLink, Object.assign({}, props)));
export default TextLink;
